import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const FilterContext = createContext(null);

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState({ mois: "all", plateforme: "all", logement: "all" });
  const [options, setOptions] = useState({ mois: [], logements: [], immeubles: {} });

  const refreshOptions = useCallback(async () => {
    const [m, l, c] = await Promise.all([api.get("/mois"), api.get("/logements"), api.get("/logements/config")]);
    setOptions({ mois: m.data, logements: l.data, immeubles: Object.fromEntries(c.data.filter((g) => g.immeuble).map((g) => [g.nom, g.immeuble])) });
  }, []);

  useEffect(() => {
    refreshOptions().catch(() => {});
  }, [refreshOptions]);

  const setFilter = (key, value) => setFilters((f) => ({ ...f, [key]: value }));
  const resetFilters = () => setFilters({ mois: "all", plateforme: "all", logement: "all" });

  return (
    <FilterContext.Provider value={{ filters, setFilter, resetFilters, options, refreshOptions }}>{children}</FilterContext.Provider>
  );
};

export const useFilters = () => useContext(FilterContext);
